import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import s from './ComponentPositionModel.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Banner from '../Banner/Banner';
import { initialModelState } from '../../reducers/initialState';
import ComponentPositionModelListTable from '../ComponentPositionModel/ComponentPositionModelListTable';
import { WidgetVisibility, IsWidgetAccessible } from '../../utils/widgetManager';
import SearchBar from '../SearchBar/SearchBar';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Cookies from 'js-cookie';
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog';
import ModelConfigurationContentTemplate from '../ModelTab/ModelConfigurationContentTemplate';
import Breadcrumb from '../WSAControls/Breadcrumb/BreadCrumb';
import { useParams } from 'react-router-dom';
import { DEFAULT_PAGE_SIZE, ModelCategoryPermission } from '../../constants';
import Pagination from '../Pagination/Pagination';
import { getModelCategoryPermission } from '../../utils';


const ComponentPositionModelList = ({
  ComponentPositionsManager = { ...initialModelState.modelManager.selectedModel.ComponentPositionModel },
  intl,
  userProfileWidgets,
  modelCategoryComponentPositions,
  getComponentPositions,
  userModelCategories,
  setCurrentPage,
  setFilterData,
  saveComponentPosition,
  deleteComponentPosition,
  setComponentPositionChange,
  setComponentPositionShowScreenStatus,
  uploadComponentToS3UpdateShadow
}) => {

  const emptyObj = { ModelComponentPositionId: 0, ModelComponentPositionLinkId: 0 };
  const envName = process.env.REACT_APP_ENV_NAME_SHORT;
  let { ModelCategoryId, ModelId } = useParams();

  useEffect(() => {
    getComponentPositions(ModelCategoryId, ModelId);
  }, [getComponentPositions, ModelCategoryId, ModelId]);

  const onPageChangeHandler = currentPage => {
    setCurrentPage(currentPage);
  };

  const searchHandler = value => {
    setCurrentPage(1);
    filteredResults(value);
  };

  const filteredResults = value => {
    let filteredList = ComponentPositionsManager.componentPositionModels;
    if (value !== '') {
      filteredList = ComponentPositionsManager.componentPositionModels.filter(function (item) {
        return item.Name.toLowerCase().includes(value.toLowerCase());
      });
    }

    setFilterData({ filteredResults: { filteredResults: filteredList } });
  };

  const dataObj = Object.values(ComponentPositionsManager.filteredResults);

  const [active, setActive] = useState(false);
  const [deleteObj, setDeleteObj] = useState(emptyObj);
  const [uploadComponentActive, setUploadComponentActive] =useState(false);

  const componentPositionLength = ComponentPositionsManager.componentPositionModels.length;


  

  const cancelHandler = status => {
    setComponentPositionShowScreenStatus(false);
  };

  const setAddHandler = () => {
    setComponentPositionShowScreenStatus(true);
    // setCurrentEditId(0);
  };

  const generateFileAndUploadTos3 = () => {
    uploadComponentToS3UpdateShadow(ModelCategoryId, ModelId);
  };


  const deleteComponentPositionHandler = obj => {
    setActive(true);
    setDeleteObj(obj);
  };

  const DeleteComponentPosition = () => {
    let saveData = deleteObj;
    saveData.ModelId = parseInt(ModelId);
    saveData.UpdatedBy = Cookies.get(`userid-${envName}`) || 0;
    deleteComponentPosition(saveData);
  };

  const handleClose = () => {
    setActive(false);
    setDeleteObj(emptyObj);
  };

  const handleConfirm = () => {
    DeleteComponentPosition();
    handleClose();
  };

  const uploadComponentHandler = () => {
    setUploadComponentActive(true);
  };


  const handleUploadComponentClose = () => {
    setUploadComponentActive(false);
  };

  const handleUploadComponentConfirm = () => {
    generateFileAndUploadTos3();
    handleUploadComponentClose();
  };


  let messageId = (ComponentPositionsManager && ComponentPositionsManager.displayMessageCode) || 'none';
  const messageText = intl.formatMessage({ id: messageId, defaultMessage: messageId });

  const isDeleteAllowed = IsWidgetAccessible(userProfileWidgets, 'MODEL_COMPONENT_POSTSITON_DELETE');
  const isAddAllowed = IsWidgetAccessible(userProfileWidgets, 'MODEL_COMPONENT_POSTSITON_ADD');
  const isUploadFileAllowed = IsWidgetAccessible(userProfileWidgets, 'MODEL_COMPONENT_POSTSITON_UPLOAD_FILE');

  const dialogTitle = intl.formatMessage({
    id: 'model.componentpositions.confirmDeleteComponentPosition',
    defaultMessage: 'Are you sure you want to delete the component position?'
  });

   const uploadComponentDialogTitle = intl.formatMessage({
    id: 'model.componentpositions.confirmUploadComponent',
    defaultMessage: 'Are you sure you want to publish components to all the units?'
  });

  const breadcrumbItems = [
    { label: <FormattedMessage id="modelcategory.modelcategory" defaultMessage="Model Category" />, href: '/operational-setup/model-category-list' },
    { label: <FormattedMessage id="model.models" defaultMessage="Models" />, href: `/operational-setup/model-category-configuration/${ModelCategoryId}/model-list` },
    { label: <FormattedMessage id="model.componentpositions" defaultMessage="Manage Component Positions" /> } // Last item has no href (current page)
  ];

  let isModelCategoryOwner = getModelCategoryPermission(userModelCategories, ModelCategoryId, ModelCategoryPermission.Owner)

  return (
    <div className={s.componentPosition}>
      {ComponentPositionsManager.isLoading && <LoadingSpinner />}
      {ComponentPositionsManager.showBanner && (
        <Banner
          failureText={messageText}
          showBanner={ComponentPositionsManager.showBanner}
          status={ComponentPositionsManager.isOpSuccessfull}
          successText={messageText}
        />
      )}
      <ConfirmDialog id="deleteDialog" title={dialogTitle} onConfirm={handleConfirm} onClose={handleClose} showDialog={active} />
      <ConfirmDialog id="UploadDialog" title={uploadComponentDialogTitle} onConfirm={handleUploadComponentConfirm} onClose={handleUploadComponentClose} showDialog={uploadComponentActive} />
      <ModelConfigurationContentTemplate selectedPage="manageModelComponentPositions" userProfileWidgets={userProfileWidgets} intl={intl}>
        <div className={s.contentWrapper}>
          <div className={s.componentHeader}>
            <div className={s.subHeading}>
              <FormattedMessage id="model.componentpositionsManage" defaultMessage="Manage Component Positions" />
              <span className={s.circle}>
                {ComponentPositionsManager.componentPositionModels.length}
              </span>
            </div>
          </div>
          <div className='pb-3'>
            <Breadcrumb items={breadcrumbItems} />
          </div>

          <Row className={s.topRow}>
            <Col sm={6} lg={4}>
              <SearchBar
                searchHandler={searchHandler}
                clearSearchInVisible={false}
                disabled={ComponentPositionsManager.showAddEditScreen}
                // initialText={filter}
                placeHolderTextId="model.componentpositions.search"
                data-unittest="searchComponentPosition"
              />
            </Col>
            <Col sm={6} lg={8}>
              {isModelCategoryOwner && <><Button
                className={s.addbutton}
                style={WidgetVisibility(userProfileWidgets, 'MODEL_COMPONENT_POSTSITON_ADD')}
                onClick={setAddHandler}
                disabled={!isAddAllowed && componentPositionLength.showAddEditScreen}
                data-unittest="addComponentPosition"
              >
                + <FormattedMessage id="model.componentpositions.addNew" defaultMessage="ADD NEW" />
              </Button>
                <Button
                  className={s.uploadbutton}
                  style={WidgetVisibility(userProfileWidgets, 'MODEL_COMPONENT_POSTSITON_UPLOAD_FILE')}
                  onClick={uploadComponentHandler}
                  disabled={!isUploadFileAllowed || componentPositionLength == 0}
                  data-unittest="uploadFileComponentPosition"
                >
                  <FormattedMessage id="model.componentpositions.publishComponentsToUnit" defaultMessage="PUBLISH COMPONENT" />
                </Button>
              </>}
            </Col>
          </Row>

          <div>
            <Pagination
              data={dataObj}
              pageSize={DEFAULT_PAGE_SIZE}
              onPageChange={onPageChangeHandler}
              startingPage={ComponentPositionsManager.currentPage}
            >
              <ComponentPositionModelListTable
                ComponentPositionsManager={ComponentPositionsManager}
                DeleteAllowed={isDeleteAllowed}
                deleteComponentPosition={deleteComponentPositionHandler}
                ModelId={ModelId}
                saveComponentPosition={saveComponentPosition}
                setComponentPositionChange={setComponentPositionChange}
                modelCategoryComponentPositions={modelCategoryComponentPositions}
                disableMode={ComponentPositionsManager.showAddEditScreen}
                cancelHandler={cancelHandler}
                IsModelCategoryOwner={isModelCategoryOwner}
              />
            </Pagination>
          </div>



        </div>
      </ModelConfigurationContentTemplate>
    </div>
  );
};



ComponentPositionModelList.propTypes = {
  modelCategoryComponentPositions: PropTypes.array,
  userProfileWidgets: PropTypes.object.isRequired,
  getComponentPositions: PropTypes.func.isRequired,
  saveComponentPosition: PropTypes.func.isRequired,
  setComponentPositionChange: PropTypes.func.isRequired,
  setComponentPositionShowScreenStatus: PropTypes.func.isRequired
};

export default injectIntl(ComponentPositionModelList);
